/* ====================================================================
   SORTAE — front-end interactions.
   Cart/checkout still run through Dawn; this layer adds the Sortae
   design behaviours: wordmark sort-in, reveal-on-scroll, transparent
   header, mobile menu, wishlist, AJAX add-to-bag (opens Dawn's cart
   drawer), PDP gallery, size-guide modal, reviews and footer accordion.
==================================================================== */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- toast ---------- */
  let toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove("show"), 2000);
  }
  window.sortaeToast = toast;

  /* ---------- letter "sort-in" animation for wordmarks ---------- */
  function sortIn(el, text) {
    if (!el || el.dataset.sorted) return;
    el.dataset.sorted = "1";
    el.innerHTML = "";
    const chars = [...text];
    const order = chars.map((_, i) => i).sort(() => Math.random() - 0.5);
    chars.forEach((c, i) => {
      const span = document.createElement("span");
      span.className = "ch";
      span.textContent = c === " " ? " " : c;
      span.style.animationDelay = (0.15 + order.indexOf(i) * 0.06) + "s";
      el.appendChild(span);
    });
  }

  /* ---------- reveal-on-scroll ---------- */
  const revealObs = "IntersectionObserver" in window
    ? new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); revealObs.unobserve(e.target); } });
      }, { threshold: 0.12 })
    : null;

  /* ---------- play door / footer wordmarks when they scroll in ---------- */
  const playObs = "IntersectionObserver" in window
    ? new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("play"); });
      }, { threshold: 0.3 })
    : null;

  /* ---------- transparent header over hero ---------- */
  function initHeader() {
    const hdr = $("#hdr, .sortae-header");
    if (!hdr) return;
    const hero = $(".hero, .chero");
    const onScroll = () => hdr.classList.toggle("solid", !hero || scrollY > hero.offsetHeight * 0.7);
    addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile menu drawer ---------- */
  function openMenu() {
    const d = $("#menuDrawer"), o = $("#menuOverlay");
    d && d.classList.add("on"); o && o.classList.add("on");
    document.body.classList.add("no-scroll");
    const rail = document.querySelector(".rail");
    if (rail) rail.style.display = "none";
  }
  function closeMenu() {
    const d = $("#menuDrawer"), o = $("#menuOverlay");
    d && d.classList.remove("on"); o && o.classList.remove("on");
    document.body.classList.remove("no-scroll");
    const rail = document.querySelector(".rail");
    if (rail) rail.style.display = "";
  }
  window.sortaeOpenMenu = openMenu;
  window.sortaeCloseMenu = closeMenu;

  /* ---------- wishlist heart (client-side localStorage) ---------- */
  document.addEventListener("click", e => {
    const w = e.target.closest(".wish");
    if (!w) return;
    e.preventDefault(); e.stopPropagation();
    const id = w.dataset.productId;
    if (!id) { w.classList.toggle("on"); return; }
    let wl = [];
    try { wl = JSON.parse(localStorage.getItem("sortae_wishlist") || "[]"); } catch (e) {}
    const i = wl.indexOf(id);
    if (i > -1) { wl.splice(i, 1); w.classList.remove("on"); }
    else { wl.push(id); w.classList.add("on"); }
    try { localStorage.setItem("sortae_wishlist", JSON.stringify(wl)); } catch (e) {}
  });

  /* ---------- touch quick-add toggle on product cards ---------- */
  window.sortaeQtoggle = function (btn) {
    const q = btn.closest(".card-img").querySelector(".quick");
    if (!q) return;
    const open = q.classList.toggle("open");
    btn.textContent = open ? "✕" : "+";
    $$(".quick.open").forEach(x => {
      if (x !== q) { x.classList.remove("open"); const b = x.closest(".card-img").querySelector(".qtog"); if (b) b.textContent = "+"; }
    });
  };

  /* ---------- AJAX add-to-bag → Dawn cart drawer ---------- */
  function cartDrawerEl() { return document.querySelector("cart-drawer"); }
  function updateBubbleFallback() {
    fetch("/cart.js").then(r => r.json()).then(cart => {
      $$("#cart-icon-bubble em, .bag em").forEach(em => {
        em.textContent = cart.item_count;
        if (cart.item_count > 0) em.removeAttribute("hidden");
      });
    }).catch(() => {});
  }
  function upsellKindFor(form) {
    var cols = (form.dataset.collections || '').toLowerCase();
    var type = (form.dataset.productType || '').toLowerCase();
    var path = (window.location.pathname || '').toLowerCase();
    var isWomen = cols.indexOf('womens-collection') > -1 || cols.indexOf('women') > -1 || type.indexOf('kurti') > -1 || path.indexOf('womens-collection') > -1;
    if (isWomen) return 'women';
    var isMen = cols.indexOf('mens-collection') > -1 || type.indexOf('kurta') > -1 || type.indexOf('shirt') > -1 || path.indexOf('mens-collection') > -1 || path.indexOf('men') > -1;
    if (isMen) return 'men';
    return null;
  }
  function ajaxAdd(form, variantId) {
    const drawer = cartDrawerEl();
    const fd = new FormData(form);
    if (variantId) fd.set("id", variantId);
    if (!fd.get("id")) return false; // no variant → let native submit run

    if (drawer && typeof drawer.getSectionsToRender === "function") {
      const ids = drawer.getSectionsToRender().map(s => s.id);
      fd.set("sections", ids.join(","));
      fd.set("sections_url", window.location.pathname);
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/javascript", "X-Requested-With": "XMLHttpRequest" },
      body: fd
    })
      .then(r => r.json())
      .then(res => {
        if (res.status) { toast(res.description || "Couldn't add to bag"); return; }
        const title = res.product_title || form.dataset.productTitle || "Item";
        const kind = upsellKindFor(form);
        const openDrawer = () => {
          toast(title + " — added to bag");
          $$("#cart-icon-bubble em, .bag em").forEach(em => em.animate(
            [{ transform: "scale(1)" }, { transform: "scale(1.5)" }, { transform: "scale(1)" }],
            { duration: 400, easing: "cubic-bezier(.22,1,.36,1)" }));
          if (drawer && res.sections && typeof drawer.renderContents === "function") {
            drawer.renderContents(res);
            if (typeof drawer.open === "function") drawer.open();
            else drawer.classList.remove("is-empty");
          } else {
            updateBubbleFallback();
          }
        };
        if (kind && typeof window.sortaeMaybeUpsell === "function") {
          window.sortaeMaybeUpsell(kind, openDrawer, {
            tags: form.dataset.productTags || '',
            handle: form.dataset.productHandle || '',
            id: form.dataset.productId || ''
          });
        } else {
          openDrawer();
        }
      })
      .catch(() => { form.submit(); });
    return true;
  }
  /* ---------- PDP color swatches + size selection ---------- */
  window.sortaePickColor = function (btn) {
    if (btn.disabled) return;
    const wrap = btn.parentNode;
    [...wrap.children].forEach(x => x.classList.remove('sel'));
    btn.classList.add('sel');

    const pdp = btn.closest('.pdp');
    const vd = document.getElementById('pdpVariantData');
    const od = document.getElementById('pdpOptionData');
    const idInput = document.getElementById('pdpVariantId');

    // Update main product image
    if (pdp && btn.dataset.image) {
      const firstImg = pdp.querySelector('.pdp-frame img');
      if (firstImg) firstImg.src = btn.dataset.image;
    }

    // Find best variant matching this color + current size (if selected)
    if (vd && od) {
      try {
        const variants = JSON.parse(vd.textContent);
        const options = JSON.parse(od.textContent);
        const colorIdx = options.findIndex(o => o.name === 'Color');
        const sizeIdx = options.findIndex(o => o.name === 'Size');
        const colorVal = btn.dataset.color;
        let match = null;

        if (colorIdx > -1) {
          const sizeWrap = pdp ? pdp.querySelector('.pdp-sizes') : null;
          const selSizeBtn = sizeWrap ? sizeWrap.querySelector('button.sel') : null;
          if (selSizeBtn && sizeIdx > -1) {
            match = variants.find(v => v.options[colorIdx] === colorVal && v.id == selSizeBtn.dataset.variantId && v.available);
          }
          if (!match) {
            match = variants.find(v => v.options[colorIdx] === colorVal && v.available);
          }
        }
        if (match && idInput) idInput.value = match.id;

        // Sync size pill UI to the matched variant
        if (sizeWrap && match) {
          sizeWrap.querySelectorAll('button').forEach(b => b.classList.remove('sel'));
          const sizeBtn = sizeWrap.querySelector('button[data-variant-id="' + match.id + '"]');
          if (sizeBtn) sizeBtn.classList.add('sel');
        }
      } catch (e) {}
    }
  };

  window.sortaePickSize = function (btn) {
    const wrap = btn.parentNode;
    [...wrap.children].forEach(x => x.classList.remove('sel'));
    btn.classList.add('sel');

    const pdp = btn.closest('.pdp');
    const vd = document.getElementById('pdpVariantData');
    const od = document.getElementById('pdpOptionData');
    const idInput = document.getElementById('pdpVariantId');
    const vid = btn.dataset.variantId;

    if (pdp && vd && od) {
      try {
        const variants = JSON.parse(vd.textContent);
        const options = JSON.parse(od.textContent);
        const colorIdx = options.findIndex(o => o.name === 'Color');
        const selColorBtn = pdp.querySelector('.color-pill.sel');
        const colorVal = selColorBtn ? selColorBtn.dataset.color : null;
        let match = null;

        if (colorIdx > -1 && colorVal) {
          match = variants.find(v => v.options[colorIdx] === colorVal && v.id == vid && v.available);
        }
        if (!match) match = variants.find(v => v.id == vid && v.available);
        if (match && idInput) idInput.value = match.id;

        // Update main image to color's image if color selected
        if (selColorBtn && selColorBtn.dataset.image) {
          const firstImg = pdp.querySelector('.pdp-frame img');
          if (firstImg) firstImg.src = selColorBtn.dataset.image;
        }
      } catch (e) {
        if (idInput) idInput.value = vid;
      }
    } else {
      if (idInput) idInput.value = vid;
    }
  };

  /* ---------- product-card size selection ---------- */
document.addEventListener("click", e => {
  const pill = e.target.closest(".sortae-add-form .size-pill");
  if (!pill || pill.disabled) return;

  const form = pill.closest("form");
  const variantInput = form && form.querySelector('input[name="id"]');
  if (!form || !variantInput) return;

  e.preventDefault();

  form.querySelectorAll(".size-pill").forEach(button => {
    button.classList.remove("sel");
  });

  pill.classList.add("sel");
  variantInput.value = pill.dataset.variantId;
});

  // Intercept size-pill / addb / mob-add submits on any sortae add form
  document.addEventListener("submit", e => {
    const form = e.target.closest(".sortae-add-form, .pdp-form");
    if (!form) return;
    const submitter = e.submitter;
    const vid = submitter && submitter.name === "id" ? submitter.value : (form.querySelector("[name=id]") ? form.querySelector("[name=id]").value : null);
    e.preventDefault();
    ajaxAdd(form, vid);
  });
  // mob-add lives outside the form (uses form="..."); catch its click too
  document.addEventListener("click", e => {
    const mob = e.target.closest(".mob-add[form]");
    if (!mob) return;
    const form = document.getElementById(mob.getAttribute("form"));
    if (!form) return;
    e.preventDefault();
    ajaxAdd(form, mob.value);
  });

  /* ================= PDP GALLERY ================= */
  function initPDPGallery() {
    const gal = $(".pdp-gal");
    if (!gal) return;
    const frames = $$(".pdp-frame", gal);
    const dotsWrap = $(".pdp-dots");
    if (dotsWrap && !dotsWrap.children.length) {
      dotsWrap.innerHTML = frames.map((_, i) => `<span${i === 0 ? ' class="on"' : ''}></span>`).join("");
    }
    const dots = dotsWrap ? $$("span", dotsWrap) : [];

    // reveal + active-dot as each frame scrolls into the pane
    if ("IntersectionObserver" in window) {
      const obs = new IntersectionObserver(es => es.forEach(en => {
        en.target.classList.toggle("in", en.isIntersecting);
        if (en.isIntersecting) {
          const vi = +en.target.dataset.v || frames.indexOf(en.target);
          dots.forEach((d, i) => d.classList.toggle("on", i === vi));
        }
      }), { root: gal, threshold: 0.55 });
      frames.forEach(f => obs.observe(f));
    } else {
      frames.forEach(f => f.classList.add("in"));
    }

    // magnify: transform-origin follows the pointer
    frames.forEach(fr => {
      const media = fr.querySelector("img, .pf");
      if (!media) return;
      fr.addEventListener("pointermove", ev => {
        const r = fr.getBoundingClientRect();
        media.style.transformOrigin = ((ev.clientX - r.left) / r.width * 100) + "% " + ((ev.clientY - r.top) / r.height * 100) + "%";
      });
    });

    // scroll-more cue done-state
    gal.addEventListener("scroll", () => {
      gal.classList.toggle("done", gal.scrollTop + gal.clientHeight >= gal.scrollHeight - 4);
    }, { passive: true });

    // mobile nav arrows
    const prev = $(".pdp-nav .prev, #pdpNavPrev");
    const next = $(".pdp-nav .next, #pdpNavNext");
    if (prev) prev.onclick = () => gal.scrollBy({ left: -gal.clientWidth, behavior: "smooth" });
    if (next) next.onclick = () => gal.scrollBy({ left: gal.clientWidth, behavior: "smooth" });

    // desktop wheel handoff: gallery pane scrolls first, then the page
    addEventListener("wheel", e => {
      if (matchMedia("(max-width:900px)").matches) return;
      const rect = gal.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const atEnd = gal.scrollTop + gal.clientHeight >= gal.scrollHeight - 2;
      const atStart = gal.scrollTop <= 0;
      if (e.deltaY > 0 && !atEnd) { gal.scrollTop += e.deltaY; e.preventDefault(); }
      else if (e.deltaY < 0 && scrollY <= 1 && !atStart) { gal.scrollTop += e.deltaY; e.preventDefault(); }
    }, { passive: false });
  }

  /* ================= SIZE GUIDE MODAL ================= */
  const SG_SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
  const SG_DATA = {
    female: { "India": [34, 36, 38, 40, 42, 44], "Bust": [81, 86, 91, 96, 102, 108], "Waist": [63, 68, 73, 78, 84, 90], "Hip": [89, 94, 99, 104, 110, 116] },
    male: { "India": [36, 38, 40, 42, 44, 46], "Chest": [91, 96, 101, 106, 112, 118], "Waist": [76, 81, 86, 91, 97, 103], "Hip": [91, 96, 101, 106, 112, 118] }
  };
  const SG_FIGS = {
    female: `<svg width="320" height="252" viewBox="0 0 320 252" fill="none"><g stroke="var(--ink)" stroke-width="1.5"><circle cx="95" cy="26" r="15"/><path d="M95 43c-11 1-18 5-22 11-9 4-13 11-14 20-1 9 2 16 6 22-4 10-6 19-5 27 1 9 6 16 12 20-4 22-4 45-2 68"/><path d="M95 43c11 1 18 5 22 11 9 4 13 11 14 20 1 9-2 16-6 22 4 10 6 19 5 27-1 9-6 16-12 20 4 22 4 45 2 68"/></g><g stroke="var(--clay)" stroke-width="1.3" stroke-dasharray="4 4"><line x1="58" y1="86" x2="200" y2="86"/><line x1="63" y1="121" x2="200" y2="121"/><line x1="57" y1="146" x2="200" y2="146"/></g><g fill="var(--clay)" font-family="Archivo,sans-serif" font-size="11" letter-spacing="2.2"><text x="210" y="90">BUST</text><text x="210" y="125">WAIST</text><text x="210" y="150">HIP</text></g></svg>`,
    male: `<svg width="320" height="252" viewBox="0 0 320 252" fill="none"><g stroke="var(--ink)" stroke-width="1.5"><circle cx="95" cy="25" r="15"/><path d="M95 42c-14 1-24 5-28 12-11 4-16 11-17 21-1 9 2 16 7 22-2 12-2 24 0 34 2 9 6 14 12 18-3 22-3 45 0 71"/><path d="M95 42c14 1 24 5 28 12 11 4 16 11 17 21 1 9-2 16-7 22 2 12 2 24 0 34-2 9-6 14-12 18 3 22 3 45 0 71"/></g><g stroke="var(--clay)" stroke-width="1.3" stroke-dasharray="4 4"><line x1="52" y1="82" x2="200" y2="82"/><line x1="57" y1="122" x2="200" y2="122"/><line x1="55" y1="150" x2="200" y2="150"/></g><g fill="var(--clay)" font-family="Archivo,sans-serif" font-size="11" letter-spacing="2.2"><text x="210" y="86">CHEST</text><text x="210" y="126">WAIST</text><text x="210" y="154">HIP</text></g></svg>`
  };
  let sgInches = false;
  function sgGender() {
    const pdp = $(".pdp");
    return pdp && pdp.dataset.gender === "male" ? "male" : "female";
  }
  function sgRender() {
    const g = sgGender(), data = SG_DATA[g];
    const head = $("#sgHead"), body = $("#sgBody"), fig = $("#sgFig");
    if (!head) return;
    head.innerHTML = "<th>Size</th>" + SG_SIZES.map(z => `<th>${z}</th>`).join("");
    body.innerHTML = Object.entries(data).map(([row, vals]) => {
      const conv = v => row === "India" ? v : (sgInches ? (v / 2.54).toFixed(1) : v);
      return `<tr><td>${row}${row !== "India" ? (sgInches ? " (in)" : " (cm)") : ""}</td>` + vals.map(v => `<td>${conv(v)}</td>`).join("") + "</tr>";
    }).join("");
    if (fig) fig.innerHTML = SG_FIGS[g];
    const sw = $("#sgSwitch"); if (sw) sw.classList.toggle("in", sgInches);
    const cm = $("#sgUnitCm"), inn = $("#sgUnitIn");
    if (cm) cm.style.color = sgInches ? "#8a7f6e" : "var(--ink)";
    if (inn) inn.style.color = sgInches ? "var(--ink)" : "#8a7f6e";
  }
  window.sgToggleUnit = function () { sgInches = !sgInches; sgRender(); };
  window.openSizeGuide = function () { sgRender(); const o = $("#sgOverlay"); if (o) { o.classList.add("on"); document.body.classList.add("sg-lock"); } };
  window.closeSizeGuide = function () { const o = $("#sgOverlay"); if (o) { o.classList.remove("on"); document.body.classList.remove("sg-lock"); } };

  /* ================= REVIEWS (localStorage-backed, demo-seeded) ================= */
  let revRating = 5;
  function revKey(h) {
  return "sortae_rev_v2_" + h;
}

function loadReviews(h) {
  try {
    const s = localStorage.getItem(revKey(h));
    if (s) return JSON.parse(s);
  } catch (e) {}

  return [];
}

  function saveReviews(h, list) { try { localStorage.setItem(revKey(h), JSON.stringify(list)); } catch (e) {} }
  function initReviews() {
    const form = $("#revForm");
    const wrap = $(".pdp-rev");
    if (!wrap) return;
    const handle = wrap.dataset.handle || "product";
    const name = wrap.dataset.title || "This piece";
    function render() {
      const list = loadReviews(handle);
      const avg = list.length ? (list.reduce((a, r) => a + r.stars, 0) / list.length).toFixed(1) : "0.0";
      const rnd = Math.round(avg);
      const starsEl = $("#revStars"), metaEl = $("#revMeta"), listEl = $("#revList");
      if (starsEl) starsEl.textContent = "★★★★★".slice(0, rnd) + "☆☆☆☆☆".slice(0, 5 - rnd);
      if (metaEl) metaEl.textContent = avg + " · " + list.length + " review" + (list.length > 1 ? "s" : "") + " · " + name;
      if (listEl) listEl.innerHTML = list.map(r => `
        <div class="rev-item">
          <div class="rev-head"><b>${r.who}</b><time>${r.when}</time></div>
          <div class="stars">${"★".repeat(r.stars)}${"☆".repeat(5 - r.stars)}</div>
          <p>${r.text.replace(/</g, "&lt;")}</p>
          ${r.v ? '<span class="rev-badge">✓ Verified buyer</span>' : ""}
        </div>`).join("");
    }
    render();
    const pick = $("#ratePick");
    if (pick) {
      revRating = 5;
      pick.innerHTML = [1, 2, 3, 4, 5].map(n => `<button type="button" data-n="${n}" class="on">★</button>`).join("");
      pick.onclick = e => {
        const b = e.target.closest("button"); if (!b) return;
        revRating = +b.dataset.n;
        $$("button", pick).forEach(x => x.classList.toggle("on", +x.dataset.n <= revRating));
      };
    }
    if (form) form.onsubmit = e => {
      e.preventDefault();
      const who = ($("#revName").value || "Anonymous").trim();
      const text = ($("#revText").value || "").trim();
      if (!text) return;
      const list = loadReviews(handle);
      list.unshift({ who, stars: revRating, when: "Just now", text, v: false });
      saveReviews(handle, list);
      form.reset();
      render();
      const first = $("#revList") && $("#revList").firstElementChild;
      if (first) first.animate([{ opacity: 0, transform: "translateY(-14px)" }, { opacity: 1, transform: "none" }], { duration: 450, easing: "cubic-bezier(.22,1,.36,1)" });
      toast("Review posted — thanks!");
    };
  }

  /* ---------- PDP accordions (progressive: works as <details>, animated if present) ---------- */
  function initAccordions() {
    const acc = $("#pdpAcc, .acc");
    if (!acc) return;
    acc.addEventListener("click", e => {
      const h = e.target.closest(".acc-head");
      if (!h || h.tagName === "SUMMARY") return;
      const item = h.parentElement, body = item.querySelector(".acc-body");
      const open = item.classList.toggle("open");
      if (body) body.style.maxHeight = open ? body.scrollHeight + "px" : "0";
    });
  }

  /* ---------- footer accordion (mobile) ---------- */
  function initFooterAccordion() {
    $$(".foot-col h4").forEach(h => {
      h.addEventListener("click", () => {
        if (!matchMedia("(max-width:800px)").matches) return;
        h.parentElement.classList.toggle("open");
      });
    });
  }

  /* ---------- account dashboard tabs (mobile bottom-bar / desktop side-nav) ---------- */
  function initAccountTabs() {
    const nav = $("#dashNav");
    if (!nav) return;
    nav.addEventListener("click", e => {
      const b = e.target.closest("button[data-t]");
      if (!b) return;
      const t = b.dataset.t;
      $$("button[data-t]", nav).forEach(x => x.classList.toggle("on", x === b));
      $$(".dash-panel").forEach(p => p.classList.toggle("on", p.dataset.panel === t));
      const active = $(`.dash-panel[data-panel="${t}"]`);
      if (active) active.animate([{ opacity: 0, transform: "translateY(16px)" }, { opacity: 1, transform: "none" }], { duration: 400, easing: "cubic-bezier(.22,1,.36,1)" });
    });
    // order tracking expanders
    document.addEventListener("click", e => {
      const head = e.target.closest(".order2-head");
      if (!head) return;
      const card = head.closest(".order2");
      const tr = card.querySelector(".track");
      const open = card.classList.toggle("open");
      if (tr) tr.style.maxHeight = open ? tr.scrollHeight + "px" : "0";
    });
  }

  /* ---------- jewellery tab switching (delegated, works with AJAX-loaded sections) ---------- */
  function initJewelleryTabs() {
    document.addEventListener("click", e => {
      const btn = e.target.closest("button[data-jtab]");
      if (!btn) return;
      const rail = btn.closest(".rail-in");
      if (!rail) return;
      const i = btn.getAttribute("data-jtab");
      const tabs = rail.querySelectorAll("button[data-jtab]");
      const section = rail.closest(".shopify-section") || document.body;
      const gridwrap = section.querySelector(".gridwrap");
      if (!gridwrap) return;
      const panels = gridwrap.querySelectorAll("[data-jpanel]");
      tabs.forEach(b => {
        const on = b === btn;
        b.classList.toggle("on", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(p => { p.hidden = p.getAttribute("data-jpanel") !== i; });
    });
  }

  function initComboTabs() {
    document.addEventListener("click", e => {
      const btn = e.target.closest("button[data-ctab]");
      if (!btn) return;
      const rail = btn.closest(".rail-in");
      if (!rail) return;
      const i = btn.getAttribute("data-ctab");
      const tabs = rail.querySelectorAll("button[data-ctab]");
      const section = rail.closest(".shopify-section") || document.body;
      const gridwrap = section.querySelector(".gridwrap");
      if (!gridwrap) return;
      const panels = gridwrap.querySelectorAll("[data-cpanel]");
      tabs.forEach(b => {
        const on = b === btn;
        b.classList.toggle("on", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(p => { p.hidden = p.getAttribute("data-cpanel") !== i; });
    });
  }

  function init() {
    $$("[data-sortin]").forEach(el => sortIn(el, el.dataset.sortin));
    if (revealObs) $$(".reveal").forEach(el => revealObs.observe(el));
    if (playObs) $$(".door, .foot-mark, .door-word").forEach(el => playObs.observe(el));
    initHeader();
    initPDPGallery();
    initReviews();
    initAccordions();
    initFooterAccordion();
    initAccountTabs();
    initJewelleryTabs();
    initComboTabs();

    // size-guide overlay backdrop click
    const sgo = $("#sgOverlay");
    if (sgo) sgo.addEventListener("click", e => { if (e.target === sgo) closeSizeGuide(); });

    addEventListener("keydown", e => { if (e.key === "Escape") { closeMenu(); if (window.closeSizeGuide) closeSizeGuide(); } });

    // hydrate wishlist hearts
    try {
      const wl = JSON.parse(localStorage.getItem("sortae_wishlist") || "[]");
      $$(".wish").forEach(w => { if (wl.includes(w.dataset.productId)) w.classList.add("on"); });
    } catch (e) {}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
